import { Import, ImportBase } from "PFTypes";
import { PropsWithChildren, useState } from "react";
import { JsonObject } from "type-fest";

import { ImportModalPageType } from "../constants/import_modal_page";
import { ImportModalContext, ImportModalContextData } from "./import_modal_context";

type ImportModalContextProviderProps = {
  initialPage?: ImportModalPageType;
  csvTemplate?: JsonObject | string;
};

export const ImportModalContextProvider = <T extends ImportBase = Import>({
  children,
  initialPage,
  csvTemplate
}: PropsWithChildren<ImportModalContextProviderProps>) => {
  const [currentPage, setCurrentPage] = useState<ImportModalPageType>(
    initialPage || ImportModalPageType.Upload
  );
  const [search, setSearch] = useState<string>("");
  const [importData, setImportData] = useState<T | null>(null);

  return (
    <ImportModalContext.Provider
      value={
        {
          currentPage,
          setCurrentPage,
          search,
          setSearch,
          importData,
          setImportData,
          csvTemplate
        } as ImportModalContextData<T>
      }
    >
      {children}
    </ImportModalContext.Provider>
  );
};
